// extracted by mini-css-extract-plugin
export default {"panel":"SelectPanel_panel__UjIhG","input":"SelectPanel_input__rU3jm","searchIcon":"SelectPanel_searchIcon__g1I3c"};